import { CONDITIONS } from './conditions';
import { SITUATIONS } from './situations';
import { GUIDES } from './guides';
import type { ArticleBody } from './types';

/** Every Learn page body, keyed by slug. Loaded only by the Learn pages. */
export const ARTICLES: Record<string, ArticleBody> = { ...CONDITIONS, ...SITUATIONS, ...GUIDES };
